import { useWeb3React } from "@web3-react/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import tonImg from "../../assets/images/shop/ton.png"
import usdtImg from "../../assets/images/shop/usdt.png"
import starImg from "../../assets/images/shop/star.png"
import bnbImg from "../../assets/images/shop/bnb.png"
import { useAccount } from "wagmi";

const useH5Config = () => {
    const [isH5] = useState(useSelector((state: any) => state.h5.isH5))
    const { address: account, isConnected } = useAccount();
    // const { activate, deactivate, account, library, active, chainId } = useWeb3React()

    const payIcon = () => {
        return (
            <>
                {
                    isH5 ?
                        <div className="flex items-center justify-center ml-1">
                            <img style={{ boxShadow: '0px 0px 6px rgba(0,0,0,.5)' }} className='w-5 h-5 rounded-[20px]' src={usdtImg} alt="" />
                            <img style={{ boxShadow: '0px 0px 6px rgba(0,0,0,.5)' }} className='w-5 h-5 rounded-[20px] ml-2' src={bnbImg} alt="" />
                        </div>
                        : <div className="flex items-center justify-center ml-1">
                            <img style={{ boxShadow: '0px 0px 6px rgba(0,0,0,.5)' }} className='w-5 rounded-[20px]' src={starImg} alt="" />
                            <img style={{ boxShadow: '0px 0px 6px rgba(0,0,0,.5)' }} className='w-5 rounded-[20px] mx-2' src={usdtImg} alt="" />
                            <img style={{ boxShadow: '0px 0px 6px rgba(0,0,0,.5)' }} className='w-5 rounded-[20px]' src={tonImg} alt="" />
                        </div>
                }
            </>
        )
    }

    const [walletAccount] = useState(account)
    return {
        isH5,
        payIcon,
        walletAccount,
    }
}

export default useH5Config

